import * as Yup from 'yup';

declare module 'yup' {
    interface StringSchema<TType, TContext, TDefault, TFlags> {
        matchMaxOneWhiteSpace(): this;
        matchZeroWhiteSpace(): this;
        matchNoLeadingAndTrailingWhiteSpaces(): this;
        matchNoLeadingAndTrailingCommas(): this;
        matchNumbersOnly(): this;
        matchDecimalNumbersOnly(): this;
        matchNumbersAndAlphabets(): this;
        matchMaxTwoDecimalNumbers(): this;
        matchNumbersAndUppercaseAlphabetsOnly(): this;
        validateCustomerName(): this;
        matchSpecialCharacters(): this;
        validateProjectName(): this;
        numericPositive(label?: string): this;
    }
}

Yup.addMethod(Yup.string, 'matchMaxOneWhiteSpace', function () {
    return this.test('match-max-one-white-space', 'Too many spaces detected', function (value) {
        const isMatch = value?.match(/[\s]{2,}/g);

        return !isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchZeroWhiteSpace', function () {
    return this.test('match-zero-white-space', 'Space not allowed', function (value) {
        const isMatch = value?.match(/[\s]/g);

        return !isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchNoLeadingAndTrailingWhiteSpaces', function () {
    return this.test('match-no-leading-and-trailing-white-spaces', 'Leading or trailing space detected', function (value) {
        const isMatch = value?.match(/^\s+|\s+$/g);

        return !isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchNoLeadingAndTrailingCommas', function () {
    return this.test('match-no-leading-and-trailing-commas', 'Leading or trailing comma detected', function (value) {
        const isMatch = value?.match(/^,+|,+$/g);

        return !isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchNumbersOnly', function () {
    return this.test('match-numbers-only', 'Invalid character detected', function (value) {
        const isMatch = value?.match(/^\d+$/g);

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchDecimalNumbersOnly', function () {
    return this.test('match-decimal-numbers-only', 'Invalid character detected', function (value) {
        if (value === undefined) return true;

        const isMatch = value?.match(/^\d+(\.\d{1,6})?$/g);

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchNumbersAndAlphabets', function () {
    return this.test('match-numbers-and-alphabets', 'Invalid character detected', function (value) {
        const isMatch = value?.match(/^[a-zA-Z0-9 ]+$/g);

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchMaxTwoDecimalNumbers', function () {
    return this.test('match-max-two-decimal-numbers', 'Invalid number detected', function (value) {
        const isMatch = value?.match(/^\d+(.\d{1,2})?$/g);

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchNumbersAndUppercaseAlphabetsOnly', function () {
    return this.test('match-numbers-and-uppercase-alphabets-only', 'Numbers and uppercase alphabets only', function (value) {
        const isMatch = value?.match(/^[A-Z0-9 .,]+$/g);

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'validateCustomerName', function () {
    return this.test('validate-customer-name', 'Invalid character detected', function (value) {
        // only allow characters, no number
        // const isMatch = value?.match(/^[a-zA-Z-',./@ ]+$/g);

        const isMatch = true;

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'validateProjectName', function () {
    return this.test('validate-project-name', 'Invalid character detected', function (value) {
        // only allow characters, no number
        // const isMatch = value?.match(/^[a-zA-Z-',./@ ]+$/g);

        const isMatch = true;

        return !!isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'matchSpecialCharacters', function () {
    return this.test('match-special-characters', 'Invalid characters detected', function (value) {
        const isMatch = value?.match(/[^a-zA-Z0-9]/g);

        return !isMatch; // return false if matched to signify error
    });
});

Yup.addMethod(Yup.string, 'numericPositive', function (label = 'Value') {
    return this
        .test(
            'is-number',
            `${label} must be a number`,
            value =>
                value !== undefined &&
        value !== '' &&
        !Number.isNaN(Number(value))
        )
        .test(
            'positive',
            `${label} must be positive`,
            value =>
                value !== undefined &&
        Number(value) > 0
        );
});

export default Yup;
